// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"pill-managing_wrapper__24sw0","pill":"pill-managing_pill__1XneV","pillItem":"pill-managing_pillItem__2GBki"};